module.exports = __webpack_public_path__ + "assets/img/1911591928118_.pic_hd.a528be34.jpg";